// extracted by mini-css-extract-plugin
module.exports = {"envivo":"styles_envivo__EAckE","img-container-v2":"styles_img-container-v2__yjNLf"};